import {
  ActiveInactiveStatus,
  EmailSendingResult,
  MembershipType,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type EmailApiType = ReturnType<typeof emailApi>;

const emailApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    sendEmailToLeads({
      emailPayload,
      leadIds,
    }: {
      emailPayload: EmailPayloadDTO;
      leadIds: number[];
    }) {
      return axiosInstance.post(`${clubPrefix}lead-send-email/no-filter`, {
        emailPayload,
        leadIds,
      });
    },
    sendEmailToLeadFilter(params: {
      emailPayload: EmailPayloadDTO;
      leadIdsToExclude?: number[];
      createdFrom?: string;
      createdTo?: string;
      smsCommunication?: boolean;
      emailCommunication?: boolean;
      leadStatusIdList?: number[];
      leadSourceIdList?: number[];
    }) {
      return axiosInstance.post<EmailSendingResult>(
        `${clubPrefix}lead-send-email/filter`,
        params,
      );
    },
    sendEmailToMembers({
      emailPayload,
      userMemberIds,
    }: {
      emailPayload: EmailPayloadDTO;
      userMemberIds: string[];
    }) {
      return axiosInstance.post<EmailSendingResult>(
        `${clubPrefix}user-member-send-email/no-filter`,
        {
          emailPayload,
          userMemberIds,
        },
      );
    },
    sendEmailToMemberFilter(params: {
      emailPayload: EmailPayloadDTO;
      userMemberIdsToExclude?: string[];
      createdFrom?: string;
      createdTo?: string;
      smsCommunication?: boolean;
      emailCommunication?: boolean;
      membershipIdList?: number[];
      membershipStatusList?: ActiveInactiveStatus[];
      membershipTypeList?: MembershipType[];
      membershipStartFrom?: string;
      membershipStartTo?: string;
      membershipCancellationFrom?: string;
      membershipCancellationTo?: string;
      membershipExpireFrom?: string;
      membershipExpireTo?: string;
      assignedStaffIdList?: string[];
      creditsRemainingFrom?: string;
      creditsRemainingTo?: string;
    }) {
      return axiosInstance.post<EmailSendingResult>(
        `${clubPrefix}user-member-send-email/filter`,
        params,
      );
    },
  };
};

type EmailPayloadDTO = {
  marketing: boolean;
  body: string;
  subject: string;
  fromEmail: string;
  bccList: string[];
};

export default emailApi;
